import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@env/environment'
import { HttpUrlEncodingCodec } from '../services/auth/encoder'

const BASE_PATH = environment.basePathExternal

@Injectable({ providedIn: 'root' })
export class LayoutZipService {
  constructor(
    private http: HttpClient,
    protected encoder: HttpUrlEncodingCodec
  ) { }

  // Fetch the single ZIP metadata/content (Base64)
  search(): Observable<any> {
    const params = new HttpParams({ encoder: this.encoder })
    return this.http.get<any>(
      `${BASE_PATH}/dynamicLayoutZips/search/all`,
      { params }
    )
  }
    deleteOne(code: any): Observable<any> {
        return this.http.delete<any>(
          `${BASE_PATH}/dynamicLayoutZips/${code}`
        )
      }

  // Save the ZIP via JSON payload
  // payload: { dataBase64: string; id?: number; code?: string; version?: number; name?: string }
  saveZipJson(payload: { dataBase64: string; id?: number; code?: string; version?: number; name?: string }): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    let body = {}
    if (payload.id == null || payload.id==undefined) {
      body = {
        zipName: payload.name ?? 'layout.zip',
        zipContent: payload.dataBase64
      }

    }
    else {
      body = {
        id: payload.id ?? null,
        code: payload.code ?? null,
        version: payload.version ?? null,
        zipName: payload.name ?? 'layout.zip',
        zipContent: payload.dataBase64
      }
    }

    return this.http.post<any>(
      `${BASE_PATH}/dynamicLayoutZips/save`,
      body,
      { headers }
    )
  }
}




